/** @format */

import CloseIcon from '@mui/icons-material/Close';
import { DialogContent, DialogTitle, IconButton } from '@mui/material';
import styled from 'styled-components';

export const DialogTitleWithButtonClose = ({ title, onClose, sx = {} }) => {
  return (
    <DialogTitle
      sx={{
        position: 'relative',
        ...sx
      }}
    >
      {title}
      {onClose && (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500]
          }}
        >
          <CloseIcon />
        </IconButton>
      )}
    </DialogTitle>
  );
};

export const DialogContentStyled = styled(DialogContent)(({ size = 'medium' }) => {
  let customeStyle = {};
  if (size === 'small') {
    customeStyle = {
      minWidth: '280px',
      maxWidth: '350px'
    };
  }
  if (size === 'medium') {
    customeStyle = {
      minWidth: '360px',
      maxWidth: '600px'
    };
  }
  return { ...customeStyle };
});
